import React from 'react';
import './BackgroundLogo.css';
import logoback from '../assets/icons/logoback.svg';

const BackgroundLogo = () => {
  return (
    <div className="background-logo">
      <img src={logoback} alt="Background Logo" />
    </div>
  );
};

export default BackgroundLogo; 